/*
 * 作者: Fultom
 * 创建时间: 2022-06-17 13:41:03
 * 最近修改时间: 2025-07-21 14:14:51
 * 功能:
 */     


export const server_api = () => {
  let baseURL, microServiceURL, baseWsUrl, storeURL;
  console.log(process.env);
  if ('development' === process.env.NODE_ENV) {
    // baseURL = 'https://pro.inglemirepharms.cn/api_v_2_2_8';
    // baseURL = 'http://10.1.20.194:8099/api_v_2_2_8'; //10.1.22.102
    // baseURL = 'http://10.1.25.60:8099/api_v_2_2_8'; //10.1.22.102
    baseURL = 'https://oss.inglemirepharms.cn/api_v_2_2_8';
    microServiceURL = 'http://139.224.112.220:8002/';
    baseWsUrl = 'wss://websocket.inglemirepharms.cn/api-websocket/websocket/';
    storeURL = 'http://139.224.112.220:7303/';
  } else {
    const env = process.env;
    console.dir(env)
    if ('test' === process.env.ENV_CONFIG) {
      baseURL = 'https://pro.inglemirepharms.cn/api_v_2_2_8';
      microServiceURL = 'http://139.224.112.220:8002/';
      baseWsUrl = 'wss://websocket.inglemirepharms.cn/api-websocket/websocket/';
      storeURL = 'http://139.224.112.220:7303/';
    } else {
      // // api
      baseURL = 'https://oss.inglemirepharms.cn/api_v_2_2_8/'; //【H5-线上地址】
      // 微服务
      microServiceURL = 'https://testbulter.inglemirepharms.cn/'; //【H5-微服务-正式环境】
      // 直播-webscoket服务
      baseWsUrl = 'wss://websocket.inglemirepharms.cn/api-websocket/websocket/';
      // 门店-服务
      storeURL = 'https://store.inglemirepharms.cn/';
    }
  }

  return { baseURL, microServiceURL, baseWsUrl, storeURL }
}



// WEBPACK FOOTER //
// ./src/config/server_api.js